import React, { useState } from 'react';
import { Card } from '@mui/material';
import Arrow from "../../../../../assets/icons/Arrow.svg";
import BackButton from './BackButton';

interface FAQItem {
  question: string;
  answer: string;
  isExpanded: boolean;
}

export default function FaqsViewAll() {
  const [faqs, setFaqs] = useState<FAQItem[]>([
    {
      question: "Question 1",
      answer:
        "Answer: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      isExpanded: true,
    },
    {
      question: "Question 2",
      answer:
        "Answer: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      isExpanded: false,
    },
    {
      question: "Question 3",
      answer:
        "Answer: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      isExpanded: false,
    },
    {
      question: "Question 4",
      answer:
        "Answer: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      isExpanded: false,
    },
    {
      question: "Question 5",
      answer:
        "Answer: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      isExpanded: false,
    },
  ]);

  const toggleFAQ = (index: number) => {
    setFaqs(faqs.map((faq, i) => {
      if (i === index) {
        return { ...faq, isExpanded: !faq.isExpanded };
      }
      return faq;
    }));
  };

  return (
    <div className="flex flex-col w-full">
      <BackButton />
      {/* FAQ Content */}
      <div className="flex flex-col gap-4 p-4">
        <h2 className="text-[18px] leading-[27px] font-semibold">FAQs</h2>
        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => (
            <Card
              key={index}
              className="flex flex-col w-full rounded-xl border border-[#F0EFF8] p-4 shadow-md"
            >
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h4 className="text-base font-semibold">{faq.question}</h4>
                <img
                  src={Arrow}
                  alt="arrow"
                  className={`w-6 h-6 transition-transform ${faq.isExpanded ? 'rotate-180' : ''}`}
                />
              </div>
              {faq.isExpanded && (
                <p className="mt-2 text-base text-[#767676] font-normal">{faq.answer}</p>
              )}
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
